import { Popper, styled } from "@mui/material";
import { ResourceType } from "utils/saastypes";

export const upgradeResourceTypes = [
  {
    name: "Both Conductor Server and Workers",
    value: ResourceType.BOTH_CONDUCTOR_AND_WORKERS,
    reference: "conductor",
    resources: [ResourceType.CONDUCTOR, ResourceType.WORKERS],
  },
  {
    name: "Conductor Server",
    value: ResourceType.CONDUCTOR,
    reference: "conductor",
    resources: [ResourceType.CONDUCTOR],
  },
  {
    name: "Conductor Workers",
    value: ResourceType.WORKERS,
    reference: "workers",
    resources: [ResourceType.WORKERS],
  },
  {
    name: "Conductor Metrics Proxy",
    value: ResourceType.METRICS_PROXY,
    reference: "metricsProxy",
    resources: [ResourceType.METRICS_PROXY],
  },
  {
    name: "Orkes Agent",
    value: ResourceType.AGENT,
    reference: "agent",
    resources: [ResourceType.AGENT],
  },
  {
    name: "MCP Workers",
    value: ResourceType.MCP_WORKER,
    reference: "mcpWorker",
    resources: [ResourceType.MCP_WORKER],
  },
  {
    name: "Conductor Server, Workers, and Metrics Proxy",
    value: ResourceType.CONDUCTOR_SERVER_WORKERS_AND_METRICS_PROXY,
    reference: "conductor",
    resources: [
      ResourceType.CONDUCTOR,
      ResourceType.WORKERS,
      ResourceType.METRICS_PROXY,
    ],
  },
];

export const resourceTypesToValidate = [
  ResourceType.WORKERS,
  ResourceType.METRICS_PROXY,
  ResourceType.BOTH_CONDUCTOR_AND_WORKERS,
  ResourceType.CONDUCTOR_SERVER_WORKERS_AND_METRICS_PROXY,
  ResourceType.CONDUCTOR,
  ResourceType.AGENT,
  ResourceType.MCP_WORKER,
];
export const StyledPopper = styled(Popper)(({ theme }) => ({
  "& .MuiAutocomplete-groupLabel": {
    color: theme.palette.text.primary,
  },
}));
export const PARAMETERS_KEY = "parameters";

export function isMajorVersionUpgrade(
  newVersion: string,
  currentVersion: string
) {
  // Extract major version from the version string
  const extractMajorVersion = (version: string) =>
    version ? parseInt(version.split(".")[0], 10) : null;

  const newMajorVersion = extractMajorVersion(newVersion);
  const currentMajorVersion = extractMajorVersion(currentVersion);

  // If current version is not a valid semantic version (custom version),
  // don't consider it a major upgrade
  if (currentMajorVersion === null) {
    return false;
  }

  if (newMajorVersion && currentMajorVersion)
    return newMajorVersion > currentMajorVersion;
}

export function isVersionWithinAllowedRange(
  targetVersion: string,
  currentVersion: string
): boolean {
  // Extract major version from the version string, handling alpha/beta suffixes
  const extractMajorVersion = (version: string) => {
    if (!version) return null;
    // Handle versions like "3.1.0-alpha1" by splitting on "-" first
    const baseVersion = version.split("-")[0];
    return parseInt(baseVersion.split(".")[0], 10);
  };

  const targetMajorVersion = extractMajorVersion(targetVersion);
  const currentMajorVersion = extractMajorVersion(currentVersion);

  // If current version is not a valid semantic version (custom version),
  // allow upgrade to any semantic version
  if (currentMajorVersion === null && targetMajorVersion !== null) {
    return true;
  }

  if (targetMajorVersion === null || currentMajorVersion === null) {
    return false;
  }

  // Allow versions within current major version and up to 1 major version above
  return targetMajorVersion <= currentMajorVersion + 1;
}
